import React from "react";
import PropTypes from "prop-types";
import { TableCell } from "investira.react.components";
import { validators } from "investira.sdk";
import { FormatNumber } from "../";

/**
 * Renderiza o componente NumberTableCell.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {number} props.value - Valor exibido ou controlado pelo componente.
 * @param {number} props.decimal - Propriedade `decimal` do componente.
 * @param {boolean} props.separateThousand - Propriedade `separateThousand` do componente.
 * @param {boolean} props.showCurrency - Propriedade `showCurrency` do componente.
 * @param {string} props.sufix - Propriedade `sufix` do componente.
 * @param {*} props.placeholder - Propriedade `placeholder` do componente.
 * @param {Object} props.sx - Estilos adicionais repassados pela prop `sx`.
 * @param {Object} props.restFormatNumberProps - Props adicionais repassadas para `restFormatNumberProps`.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const NumberTableCell = (props) => {
  const {
    sufix = "",
    placeholder = "---",
    value,
    sx,
    ...restFormatNumberProps
  } = props;

  return (
    <TableCell sx={{ textAlign: "right", ...sx }}>
      {!validators.isEmpty(value) ? (
        <FormatNumber value={value} {...restFormatNumberProps} sufix={sufix} />
      ) : (
        placeholder
      )}
    </TableCell>
  );
};

NumberTableCell.propTypes = {
  value: PropTypes.number,
  decimal: PropTypes.number,
  separateThousand: PropTypes.bool,
  showCurrency: PropTypes.bool,
  sufix: PropTypes.string,
  //placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element, PropTypes.node, PropTypes.func])
};

export default NumberTableCell;
